import { capitalize } from 'app/utils';

/**
 * @description This function receives the resume object, related to visits by 
 * health professionals associated with a PAD and prepares a response object for 
 * rendering in the weekly visit calendar.
 * 
 * @param {Object} resume Object whose keys are the days of the week and the values 
 * are arrays of visits separated by completed, planned and not completed visits.
 */
export function prepareData(resume) {

  let completed = [];
  let planned = [];
  let notCompleted = [];
  
  for (const day in resume) {
    completed = [...completed, ...resume[day]['completed']];
    planned = [...planned, ...resume[day]['planned']];
    notCompleted = [...notCompleted, ...resume[day]['notCompleted']];
  }

  completed = buildVisitObject(completed, 'completed');
  planned = buildVisitObject(planned, 'planned');
  notCompleted = buildVisitObject(notCompleted, 'notCompleted');

  return [ ...completed, ...planned, ...notCompleted ]
}

function buildVisitObject(visits, status) {
  return visits.map(visit => {
    const { id, arrivalDate, start, end, profession, professional } = visit;
    const { name: professionName } = profession;
    const { name: professionalName } = professional;

    let hexColor;

    switch (status) {
      case 'completed':
        hexColor = '#66C39B'
        break;
      case 'planned':
        hexColor = '#FFF956'
        break;
      case 'notCompleted':
        hexColor = '#E98777'
        break;
    
      default:
        break;
    }

    return {
      id,
      professionName: capitalize(professionName),
      professionalName: capitalize(professionalName),
      start: start ? new Date(start) : new Date(arrivalDate),
      end: end ? new Date(end) : new Date(arrivalDate),
      visitStatus: status,
      hexColor,
      arrivalDate
    }

  })
}
